<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <DxToolbar class='select-group'>
        <DxItem
          #default
          location="before"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>년도 : </b></div>
        </DxItem>
        <DxItem
          :options="selectBoxYearOptions"
          location="before"
          locate-in-menu="auto"
          widget="dxSelectBox"
        />
        <DxItem
          #default
          location="before"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>월 : </b></div>
        </DxItem>
        <DxItem
          :options="selectBoxMonthOptions"
          location="before"
          locate-in-menu="auto"
          widget="dxSelectBox"
        />
        <DxItem
          :options="excelExportBtn"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
        />

      </DxToolbar>

      <div style="display:flex;">
        <table class="sales">
          <thead>
            <tr>
              <th rowspan="2" colspan="2" class="right-line">항 목</th>
              <th colspan="5" class="right-line-bold"> 매출현황</th>
            </tr>
            <tr>
              <th class="top-line right-line ">예상매출액</th>
              <th class="top-line right-line ">납입매출액</th>
              <th class="top-line right-line">계산서금액</th>
              <th class="top-line right-line">부가액/계산서중량</th>
              <th class="top-line right-line-bold width-5">%</th>
            </tr>
          </thead>
          <tbody>
            <!-- section 1 start -->
            <tr v-for="(item,index1)  in salesList" :key="index1+0">
              <td v-if="index1===0" :rowspan="section1Row + 1" class="b-line  width-6 center"> 부 품</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.코드명 }}</td>
              <td class="b-line  right-line width-8"> {{ item.예상매출액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ item.납입매출액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> {{ item.예상부가액|comma }}</td>
              <td class="b-line  right-line-bold"> {{ item.예상이익율 }}</td>
              <!-- <td class="b-line  right-line-bold"> {{ item.계산이익율 }}</td> -->
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> {{ total예상매출액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ total납입매출액|comma }}</td>
              <td class="b-line right-line width-8"> {{ total계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> {{ total예상부가액|comma }}</td>
              <td class="b-line  right-line-bold"> {{ total예상이익율|comma }}</td>
            </tr>
            <!-- section 1 end -->
            <!-- section 2 start -->
            <tr v-for="(item,index1)  in coilSalesList" :key="index1+10">
              <td v-if="index1===0" :rowspan="section2Row + 1" class="b-line width-6 center"> 원자재</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.거래처명|comma }}</td>
              <td class="b-line  right-line width-8"> {{ item.예상매출액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ item.사급매출액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> {{ item.계산서중량|comma }}</td>
              <td class="b-line  right-line-bold"> {{ item.실적달성률 }}</td>
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> {{totalCoil예상매출액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ totalCoil사급매출액|comma}}</td>
              <td class="b-line right-line width-8"> {{ totalCoil계산서금액|comma}}</td>
              <td class="b-line  right-line width-8"> {{ totalCoil계산서중량|comma}}</td>
              <td class="b-line  right-line-bold"> {{ totalCoil예상달성률|comma}}</td>
            </tr>
            <!-- section 2 end -->
            <!-- section 3 start -->
            <tr v-for="(item,index1)  in scrapSalesList" :key="index1+20">
              <td v-if="index1===0" :rowspan="section3Row + 1" class="b-line  width-6 center"> 스크랩</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.title }}</td>
              <td class="b-line  right-line width-8"> {{ item.계획스크랩|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ item.실적스크랩|comma }}</td>
              <td class="b-line right-line width-8"> </td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line-bold"> </td>
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >금액</td>
              <td class="b-line  right-line width-8"> {{ totalScrap계획스크랩|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ totalScrap실적스크랩|comma }}</td>
              <td class="b-line right-line width-8"> </td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line-bold"> </td>
            </tr>
            <!-- section 3 end -->
            <!-- section 4 start -->
            <tr v-for="(item,index1)  in section4Row" :key="index1+30">
              <td v-if="index1===0" :rowspan="section4Row + 1" class="b-line  width-6 center"> 기 타</td>
              <td class="b-line left-line right-line width-7" ></td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line  width-8"> </td>
              <td class="b-line right-line width-8"> </td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line-bold"> </td>
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line  width-8"> </td>
              <td class="b-line right-line width-8"> </td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line-bold"> </td>
            </tr>
            <!-- section 4 end -->
            <!-- GRAND TOTAL -->
            <tr class="b-line-bold total-color">
              <td colSpan="2" class="b-line right-line width-6 center" >GRAND TOTAL</td>
              <td class="b-line  right-line width-8"> {{grandTotal예상매출액|comma}}</td>
              <td class="b-line  right-line  width-8"> {{grandTotal납입매출액|comma}}</td>
              <td class="b-line right-line width-8"> {{grandTotal계산서금액|comma}}</td>
              <td class="b-line  right-line width-8"> {{grandTotal부개액|comma}}</td>
              <td class="b-line  right-line-bold"> </td>
            </tr>

          </tbody>
        </table>
        <!-- RIGHT TABLE START -->
        <!-- RIGHT TABLE START -->
        <!-- RIGHT TABLE START -->
        <table class="sales" style="margin-left:1px;">
          <thead>
            <tr>
              <th rowspan="2" colspan="2" class="right-line">항 목</th>
              <th colspan="5" class="right-line-bold"> 매입현황</th>
            </tr>
            <tr>
              <th class="top-line right-line ">예상매입액</th>
              <th class="top-line right-line ">실적매입액</th>
              <th class="top-line right-line">계산서금액</th>
              <th class="top-line right-line">이월금액</th>
              <th class="top-line right-line-bold width-5">%</th>
            </tr>
          </thead>
          <tbody>
            <!-- section 5 start -->
            <tr v-for="(item,index1)  in coilPurchaseList" :key="index1+140">
              <td v-if="index1===0" :rowspan="section5Row + 1" class="b-line  width-6 center"> 원자재</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.코드명 }}</td>
              <td class="b-line  right-line width-8"> {{ item.예상매입액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ item.실적매입액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> {{ item.이월금액|comma }}</td>
              <td class="b-line  right-line-bold"> {{ item.매입달성률 }}</td>
              <!-- <td class="b-line  right-line-bold"> {{ item.계산이익율 }}</td> -->
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> {{ totalCoil예상매입액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ totalCoil실적매입액|comma }}</td>
              <td class="b-line right-line width-8"> {{ totalCoil매입계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> {{ totalCoil이월금액|comma }}</td>
              <td class="b-line  right-line-bold"> {{ totalCoil매입달성률|comma }}</td>
            </tr>
            <!-- section 5 end -->
            <!-- section 6 start -->
             <tr v-for="(item,index1)  in outsourcePurchaseList" :key="index1+40">
              <td v-if="index1===0" :rowspan="section6Row + 1" class="b-line  width-6 center"> 외주품</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.거래처명 }}</td>
              <td class="b-line  right-line width-8"> {{ item.예상매입액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ item.실적매입액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.계산서금액|comma }}</td>
              <td class="b-line  right-line width-8">{{ item.이월금액|comma }}  </td>
              <td class="b-line  right-line-bold"> {{ item.매입달성률 }}</td>
              <!-- <td class="b-line  right-line-bold"> {{ item.계산이익율 }}</td> -->
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> {{ total외주품예상매입액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ total외주품실적매입액|comma }}</td>
              <td class="b-line right-line width-8"> {{ total외주품매입계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> {{ total외주품이월금액|comma }}</td>
              <td class="b-line  right-line-bold"> {{ total외주품매입달성률|comma }}</td>
            </tr>
            <!-- section 6 end -->
            <!-- section 7 start -->
            <tr v-for="(item,index1)  in subcontractPurchaseList" :key="index1+50">
              <td v-if="index1===0" :rowspan="section7Row + 1" class="b-line width-6 center"> 도급</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.거래처명|comma }}</td>
              <td class="b-line  right-line width-8"> {{ item.예상매입액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ item.실적매입액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.계산서금액|comma }}</td>
              <td class="b-line  right-line width-8"> </td>
              <td class="b-line  right-line-bold"> {{ item.매입달성률 }}</td>
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> {{total부품예상매입액|comma }}</td>
              <td class="b-line  right-line  width-8"> {{ total부품실적매입액|comma}}</td>
              <td class="b-line right-line width-8"> {{ total부품매입계산서금액|comma}}</td>
              <td class="b-line  right-line width-8"> 0 </td>
              <td class="b-line  right-line-bold"> {{ total부품매입달성률|comma}}</td>
            </tr>
            <!-- section 7 end -->
            <!-- section 8 start -->
            <tr v-for="(item,index1)  in hardwarePurchaseList" :key="index1+60">
              <td v-if="index1===0" :rowspan="section8Row + 1" class="b-line  width-6 center"> H/WARE</td>
              <td class="b-line left-line right-line width-7 center" >{{ item.코드명|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.예상매입액|comma }}</td>
              <td class="b-line right-line  width-8"> {{ item.실적매입액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.계산서금액|comma }}</td>
              <td class="b-line right-line width-8"> {{ item.이월금액|comma }}</td>
              <td class="b-line right-line-bold"> {{ item.매입달성률 }}</td>
            </tr>
            <tr class="b-line-bold total-color">

              <td class="b-line right-line width-7 center" >TOTAL</td>
              <td class="b-line  right-line width-8"> {{ total하드웨어예상매입액|comma}}</td>
              <td class="b-line  right-line  width-8"> {{ total하드웨어실적매입액|comma}}</td>
              <td class="b-line right-line width-8"> {{ total하드웨어매입계산서금액|comma}}</td>
              <td class="b-line  right-line width-8"> {{ total하드웨어이월금액|comma}}</td>
              <td class="b-line  right-line-bold"> {{ total하드웨어매입달성률|comma}}</td>
            </tr>
            <!-- section 8 end -->
            <!-- GRAND TOTAL -->
            <tr class="b-line-bold total-color">
              <td colSpan="2" class="b-line right-line width-6 center" >GRAND TOTAL</td>
              <td class="b-line  right-line width-8"> {{grandTotal예상매입액|comma}}</td>
              <td class="b-line  right-line  width-8"> {{grandTotal실적매입액|comma}}</td>
              <td class="b-line right-line width-8"> {{grandTotal매입계산서금액|comma}}</td>
              <td class="b-line  right-line width-8"> {{grandTotal이월금액|comma}}</td>
              <td class="b-line right-line-bold"> </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import axios from 'axios'
import FileService from '../../share/service/FileService'
import HttpService from '../../share/service/HttpService'

export default {
  name: 'monthPlanVsResult',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '월계획대비실적'
        }
      ],
      excelExportBtn: {
        hint: '엑셀 다운로드',
        icon: 'exportxlsx',
        type: 'default',
        text: '엑셀저장',
        focusStateEnabled: true,
        onClick: (args) => {
          this.downloadExcelFile()
        }
      },
      thisYear: null,
      selectedMonth: null,
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      section1Row: 8, // 부품
      section2Row: 8,
      section3Row: 2,
      section4Row: 3, // 기타
      // RIGHT TABLE ROW
      section5Row: 5, // 부품
      section6Row: 5, // 외주품
      section7Row: 4, // 도급
      section8Row: 7, // 하드웨어
      salesInfoList: null,
      salesList: null,
      coilSalesList: null, // 원자재매출
      scrapSalesList: null, // 매출 스크랩
      coilPurchaseList: null, // 원자재매입
      subcontractPurchaseList: null, // 부품매입
      hardwarePurchaseList: null, // 하드웨어매입
      outsourcePurchaseList: null, // 외주품 매입
      // 부품
      total예상매출액: null,
      total납입매출액: null,
      total계산서금액: null,
      total예상부가액: null,
      total예상이익율: null,
      // 원자재 매출
      totalCoil예상매출액: null,
      totalCoil사급매출액: null,
      totalCoil계산서금액: null,
      totalCoil계산서중량: null,
      totalCoil예상달성률: null,
      // SCRAP
      totalScrap계획스크랩: null,
      totalScrap실적스크랩: null,
      // 원자재 매입
      totalCoil예상매입액: null,
      totalCoil실적매입액: null,
      totalCoil매입계산서금액: null,
      totalCoil이월금액: null,
      totalCoil매입달성률: null,
      // 부품 매입
      total부품예상매입액: null,
      total부품실적매입액: null,
      total부품매입계산서금액: null,
      total부품매입달성률: null,
      // 하드웨어 매입
      total하드웨어예상매입액: null,
      total하드웨어실적매입액: null,
      total하드웨어매입계산서금액: null,
      total하드웨어이월금액: null,
      total하드웨어매입달성률: null,
      // 외주품매입 매입
      total외주품예상매입액: null,
      total외주품실적매입액: null,
      total외주품매입계산서금액: null,
      total외주품이월금액: null,
      total외주품매입달성률: null,
      // 매출 GRAND TOTAL
      grandTotal예상매출액: null,
      grandTotal납입매출액: null,
      grandTotal계산서금액: null,
      grandTotal부개액: null,
      // 매입 GRAND TOTAL
      grandTotal예상매입액: null,
      grandTotal실적매입액: null,
      grandTotal매입계산서금액: null,
      grandTotal이월금액: null

    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxToolbar,
    DxItem
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    this.selectedMonth = AppLib.getThisMonth()

    let tempArray = []
    for (let i = this.thisYear; i >= 2020; i--) {
      tempArray.push({ 'year': i })
    }
    this.selectBoxYearOptions = {
      width: 70,
      items: tempArray,
      valueExpr: 'year',
      displayExpr: 'year',
      value: this.thisYear,
      onValueChanged: (args) => {
        this.thisYear = args.value
        this.refreshTable()
      }
    }
    tempArray = []
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        tempArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        tempArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.selectBoxMonthOptions = {
      width: 70,
      items: tempArray,
      valueExpr: 'value',
      displayExpr: 'name',
      value: this.selectedMonth,
      onValueChanged: (args) => {
        this.selectedMonth = args.value
        this.refreshTable()
      }
    }

    this.refreshTable()
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    downloadExcelFile () {
      this.isLoading = true
      const downFileName = `${this.thisYear}-${this.selectedMonth}-계획대실적.xlsx`
      const param = {}
      param.sales = this.salesList
      param.coilSales = this.coilSalesList
      param.scrapSales = this.scrapSalesList
      param.coilPurchase = this.coilPurchaseList
      param.pressPurchasee = this.outsourcePurchaseList
      param.dokub = this.subcontractPurchaseList
      param.hardwarePurchase = this.hardwarePurchaseList
      param.계획스크랩금액 = this.totalScrap계획스크랩
      param.실적스크랩금액 = this.totalScrap실적스크랩
      // console.log(param)

      FileService.downloadPostFileWithParam(param, '/exportExcelPlanVsResult', downFileName)
        .then((data) => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    makeRowData (reponse) {
      this.total예상매출액 = 0
      this.total납입매출액 = 0
      this.total계산서금액 = 0
      this.total예상부가액 = 0
      this.total예상이익율 = 0
      this.totalCoil예상매출액 = 0
      this.totalCoil사급매출액 = 0
      this.totalCoil계산서금액 = 0
      this.totalCoil계산서중량 = 0
      this.totalCoil예상달성률 = 0
      this.totalScrap계획스크랩 = 0
      this.totalScrap실적스크랩 = 0
      this.totalCoil예상매입액 = 0
      this.totalCoil실적매입액 = 0
      this.totalCoil매입계산서금액 = 0
      this.totalCoil이월금액 = 0
      this.totalCoil매입달성률 = 0
      this.total부품예상매입액 = 0
      this.total부품실적매입액 = 0
      this.total부품매입계산서금액 = 0
      this.total부품매입달성률 = 0
      this.total하드웨어예상매입액 = 0
      this.total하드웨어실적매입액 = 0
      this.total하드웨어매입계산서금액 = 0
      this.total하드웨어매입달성률 = 0
      this.total하드웨어이월금액 = 0
      this.total외주품예상매입액 = 0
      this.total외주품실적매입액 = 0
      this.total외주품매입계산서금액 = 0
      this.total외주품매입달성률 = 0
      this.total외주품이월금액 = 0

      for (let i = 0; i < reponse.length; i++) {
        if (i === 0) { // 매출
          this.salesList = this.$_sp.MakeModel(reponse[i])
          this.salesList.forEach(item => {
            this.total예상매출액 += item.예상매출액
            this.total납입매출액 += item.납입매출액
            this.total계산서금액 += item.계산서금액
            this.total예상부가액 += item.예상부가액
          })
          if (this.salesList.length > 0) {
            this.total예상이익율 = `${Math.round(this.total예상부가액 / this.total예상매출액 * 100)}%`
          }
          let addRow = this.section1Row - this.salesList.length
          for (let j = 0; j < addRow; j++) {
            this.salesList.push({})
          }
          console.log(this.salesList)
        } else if (i === 1) { // 원자재 매출
          this.coilSalesList = this.$_sp.MakeModel(reponse[i])
          this.coilSalesList.forEach(item => {
            this.totalCoil예상매출액 += item.예상매출액
            this.totalCoil사급매출액 += item.사급매출액
            this.totalCoil계산서금액 += item.계산서금액
            this.totalCoil계산서중량 += item.계산서중량
          })
          if (this.coilSalesList.length > 0) {
            this.totalCoil예상달성률 = `${Math.round(this.totalCoil계산서금액 / this.totalCoil예상매출액 * 100)}%`
          }
          let addRow = this.section2Row - this.coilSalesList.length
          for (let j = 0; j < addRow; j++) {
            this.coilSalesList.push({})
          }
          console.log(this.coilSalesList)
        } else if (i === 2) { // 스크랩 매출
          this.scrapSalesList = this.$_sp.MakeModel(reponse[i])
          this.scrapSalesList.forEach(item => {
            this.totalScrap계획스크랩 += item.계획스크랩
            this.totalScrap실적스크랩 += item.실적스크랩
          })
          this.totalScrap계획스크랩 = this.totalScrap계획스크랩 * this.scrapSalesList[0].스크랩단가
          this.totalScrap실적스크랩 = this.totalScrap실적스크랩 * this.scrapSalesList[0].스크랩단가
          let addRow = this.section3Row - this.scrapSalesList.length
          for (let j = 0; j < addRow; j++) {
            this.scrapSalesList.push({})
          }
          console.log(this.scrapSalesList)
        } else if (i === 3) { // 원자재 매입
          this.coilPurchaseList = this.$_sp.MakeModel(reponse[i])
          console.log(this.coilPurchaseList)
          this.coilPurchaseList.forEach(item => {
            this.totalCoil예상매입액 += item.예상매입액
            this.totalCoil실적매입액 += item.실적매입액
            this.totalCoil매입계산서금액 += item.계산서금액
            this.totalCoil이월금액 += item.이월금액
          })
          if (this.coilPurchaseList.length > 0) {
            this.totalCoil매입달성률 = `${Math.round(this.totalCoil매입계산서금액 / this.totalCoil예상매입액 * 100)}%`
          }
          let addRow = this.section5Row - this.coilPurchaseList.length
          for (let j = 0; j < addRow; j++) {
            this.coilPurchaseList.push({})
          }
          console.log(this.coilPurchaseList)
        } else if (i === 4) { // 도급 매입
          this.subcontractPurchaseList = this.$_sp.MakeModel(reponse[i])
          console.log(this.subcontractPurchaseList)
          this.subcontractPurchaseList.forEach(item => {
            this.total부품예상매입액 += item.예상매입액
            this.total부품실적매입액 += item.실적매입액
            this.total부품매입계산서금액 += item.계산서금액
          })
          if (this.subcontractPurchaseList.length > 0) {
            this.total부품매입달성률 = `${Math.round(this.total부품매입계산서금액 / this.total부품예상매입액 * 100)}%`
          }
          let addRow = this.section7Row - this.subcontractPurchaseList.length
          for (let j = 0; j < addRow; j++) {
            this.subcontractPurchaseList.push({})
          }
          console.log(this.subcontractPurchaseList)
        } else if (i === 5) { // 하드웨어 매입
          this.hardwarePurchaseList = this.$_sp.MakeModel(reponse[i])
          console.log(this.hardwarePurchaseList)
          this.hardwarePurchaseList.forEach(item => {
            this.total하드웨어예상매입액 += item.예상매입액
            this.total하드웨어실적매입액 += item.실적매입액
            this.total하드웨어이월금액 += item.이월금액
            this.total하드웨어매입계산서금액 += item.계산서금액
          })
          if (this.hardwarePurchaseList.length > 0) {
            this.total하드웨어매입달성률 = `${Math.round(this.total하드웨어매입계산서금액 / this.total하드웨어예상매입액 * 100)}%`
          }
          let addRow = this.section8Row - this.hardwarePurchaseList.length
          for (let j = 0; j < addRow; j++) {
            this.hardwarePurchaseList.push({})
          }
          console.log(this.hardwarePurchaseList)
        } else if (i === 6) { // 외주품 매입
          this.outsourcePurchaseList = this.$_sp.MakeModel(reponse[i])
          console.log(this.outsourcePurchaseList)
          this.outsourcePurchaseList.forEach(item => {
            this.total외주품예상매입액 += item.예상매입액
            this.total외주품실적매입액 += item.실적매입액
            this.total외주품이월금액 += item.이월금액
            this.total외주품매입계산서금액 += item.계산서금액
          })
          if (this.outsourcePurchaseList.length > 0) {
            this.total외주품매입달성률 = `${Math.round(this.total외주품매입계산서금액 / this.total외주품예상매입액 * 100)}%`
          }
          let addRow = this.section6Row - this.outsourcePurchaseList.length
          for (let j = 0; j < addRow; j++) {
            this.outsourcePurchaseList.push({})
          }
          console.log(this.outsourcePurchaseList)
        }
        this.grandTotal예상매출액 = this.totalCoil예상매출액 + this.totalScrap계획스크랩 + this.total예상매출액
        this.grandTotal납입매출액 = this.total납입매출액 + this.totalScrap실적스크랩 + this.totalCoil사급매출액
        this.grandTotal계산서금액 = this.total계산서금액 + this.totalCoil계산서금액
        this.grandTotal부개액 = this.total예상부가액
        this.grandTotal예상매입액 = this.totalCoil예상매입액 + this.total외주품예상매입액 + this.total부품예상매입액 + this.total하드웨어예상매입액
        this.grandTotal실적매입액 = this.totalCoil실적매입액 + this.total외주품실적매입액 + this.total부품실적매입액 + this.total하드웨어실적매입액
        this.grandTotal매입계산서금액 = this.totalCoil매입계산서금액 + this.total외주품매입계산서금액 + this.total부품실적매입액 + this.total하드웨어매입계산서금액
        this.grandTotal이월금액 = this.totalCoil이월금액 + this.total외주품이월금액 + this.total하드웨어이월금액
      }
    },
    async refreshTable () {
      const param = {
        fromDate: `${this.thisYear}-${this.selectedMonth}-01`,
        toDate: `${this.thisYear}-${this.selectedMonth}-${AppLib.getMonthLastDay(this.thisYear, this.selectedMonth)} 23:59:59`
      }
      await this.$_sp.runNoEncodeFindSqlProc('도급월마감', { 납품기준월: param.fromDate })
        .then(async (data) => {
          let count = this.$_sp.MakeModel(data)
          if (count.length === 0) {
            param.title = `${this.doKubDate}월 납품수량`
            await HttpService.reqPostBody(this.$_sp.makeParamModel(param), '/saveMrpV2')
              .then(() => {
              })
          }
        })
      const sales = this.$_sp.runNoEncodeFindProc('spFindAllSalesAmountByMonthAndGbCompnay', param) // 부품 매입
      const coilSales = this.$_sp.runNoEncodeFindProc('spFindAllCoilSalesAmountByMonthAndGbCompnay', param) // 코일 매입
      const scrapSales = this.$_sp.runNoEncodeFindProc('spFindAllScrapSalesAmountByMonthAndGbCompnay', param) // 스크랩 매출
      const coilPurchase = this.$_sp.runNoEncodeFindProc('spFindAllCoilPurchaseAmountByMonthAndGbCompnay', param) // 원자재 매입
      const subcontractPurchase = this.$_sp.runNoEncodeFindProc('spFindAllSubcontractPurchaseAmountByMonthAndGbCompnay', param) // 도급 매입
      const hardwarePurchase = this.$_sp.runNoEncodeFindProc('spFindAllHardwarePurchaseAmountByMonthAndGbCompnay', param) // 하드웨어 매입
      const outsourcePurchase = this.$_sp.runNoEncodeFindProc('spFindAllOutsourcePurchaseAmountByMonthAndGbCompnay', param) // 외주품 매입
      this.isLoading = true
      axios.all([sales, coilSales, scrapSales, coilPurchase, subcontractPurchase, hardwarePurchase, outsourcePurchase])
        .then(axios.spread((...response) => {
          this.isLoading = false
          this.makeRowData(response)
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
  .sales{
    border-collapse: collapse;
    width: 100%;
    border: 2px solid #3c3c3c;
    padding: 0;
    .top-line{
      border-top: 1px solid gray;
    }
    .b-line{
      border-top: 1px solid gray;
    }
    .b-line-bold{
      border-bottom: 2px solid gray;
    }
    .right-line {
      border-right: 1px solid gray;
    }
    .left-line {
      border-left: 1px solid gray;
    }
    .right-line-bold {
      border-right: 2px solid gray;
    }
    .width-5 {
      width:5%
    }
    .width-6 {
      width: 6%
    }
    .width-7 {
      width: 7%
    }
    .width-8 {
      width: 8%
    }
    thead{
      border-bottom: 2px solid black;
      tr{
        padding: 0;
        background-color: rgba(239, 239, 239, 0.812);
      }
      th{
        text-align: center;
        padding:4px;
        // border-right: 1px solid gray;
        // border-top: 1px solid gray;
      }
    }
    tbody{
      td{
        height: 26.5px;
        text-align: right;
        padding:0 2px;
      }
      .right {
        text-align: right;
      }
      .center{
        text-align: center;
      }
      .left{
        text-align: left;
      }
    }
    .total-color{
      background-color: rgba(236, 236, 236, 0.909);
    }
  }
</style>
